import { getLayersArray } from '@meitu/saas-editor-core/es/utils/layer-kit';
import { ILayerProps, LayerType } from '@meitu/saas-editor-core/es/version-types';

export const getLayerType = (activeLayer: ILayerProps) => {
    let layerType = 0;
    let layerNum = 1;
    if (activeLayer && activeLayer.children && activeLayer.children.length) {
        // 拍平
        const newLayers = getLayersArray([activeLayer]);

        // 计算图层数不需要分组图层
        const len = newLayers.filter((layer) => layer.layerType !== LayerType.GROUP_LAYER).length;
        let textSign: number = 0;
        let imgSign: number = 0;
        let hasGroup: boolean = false;
        /** layer_type 值为以下
         * 1	图层组，文字+文字
         * 2	图层组，图片+图片
         * 3	图层组，文字+图片
         * 4	组+x（x为任意类型，含文字、图片、组）
         */

        for (let i = 0; i < newLayers.length; i++) {
            const { layerType } = newLayers[i];
            if (hasGroup) {
                break;
            }
            switch (layerType) {
                case LayerType.TEXT_LAYER:
                    textSign = 1;
                    break;
                case LayerType.IMAGE_LAYER:
                    imgSign = 2;
                    break;
                case LayerType.GROUP_LAYER:
                    hasGroup = true;
                    break;
            }
        }
        layerType = hasGroup ? 4 : textSign + imgSign;

        // 获取图层数量
        layerNum = len;
    }

    return {
        layerType,
        layerNum,
    };
};
/**
 * hb_layers_func_click & hb_layers_func_use 埋点
 */
export const HandleHbLayersFunc = (props: {
    firstId: number;
    secondId: number;
    isClick?: boolean;
    isUse?: boolean;
    recordId: string;
    layerType?: number;
    canvas_type?: number;
}) => {
    const { firstId, secondId, isClick, isUse, recordId, layerType, canvas_type } = props;
    const layer_num = 1;

    const statTrackData: { [key: string]: unknown } = {
        record_id: recordId,
        layer_num,
        layer_type: layerType,
        func_id: `${firstId}_${secondId}`,
    };
    if (canvas_type !== void 0) {
        statTrackData.canvas_type = canvas_type;
    }
    if (isClick) {
        window._stat_track('hb_layers_func_click', statTrackData);
    }
    if (isUse) {
        window._stat_track('hb_layers_func_use', statTrackData);
    }
};
